import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { Badge } from "./ui/badge"
import { Button } from "./ui/button"
import { SquareArrowOutUpRight } from "lucide-react"
import moment from "moment"
import "moment/locale/pt-br";
import getServico from "@/utils/getServico"
import getUnidade from "@/utils/getUnidade"
import { BadgeStatus } from "./badgeStatus"

export function TableAdmin({ data = [], handleDetalhe }) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[160px]">Enviada</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Serviço</TableHead>
          <TableHead>CPF</TableHead>
          <TableHead>Esperando</TableHead>
          <TableHead className="text-right">Ações</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map(item => (
          <TableRow key={item._id}>
            <TableCell className="font-medium">{moment(item.createdAt).format("DD/MM/YYYY HH:mm")}</TableCell>
            <TableCell>
              <BadgeStatus finalizado={item.finalizado} inProgress={item.inProgress} />
            </TableCell>
            <TableCell>
              {getServico(item.setor, item.servico)}
              {item.unidade_origem && item.unidade_origem !== getUnidade(item.unidade) && (
                <Badge variant="outline" className="ml-2">{item.unidade_origem}</Badge>
              )}
            </TableCell>
            <TableCell>{item.cpf}</TableCell>
            <TableCell>{item.finalizado ? "-" : moment(item.createdAt).fromNow()}</TableCell>
            <TableCell className="text-right">
              <Button onClick={() => handleDetalhe(item._id)} variant="secondary" size="sm" className="cursor-pointer">
                Visualizar
                <SquareArrowOutUpRight />
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}